module.exports = __webpack_public_path__ + "img/Survey-Form-Education.7953062a.png";